import { Admin, CustomRoutes, defaultTheme, Layout } from 'react-admin';
import './App.css';
import authProvider from './providers/auth.provider';

import { ThemeOptions } from '@mui/material';
import axios from 'axios';
import { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { DashboardGate } from './Dashboard/DashboardGate';
import AdminLogin from './components/Login/AdminLogin';
import EventInvitesList from './components/EventInvites/EventInvitesList';
import FamilyInvitesList from './components/FamilyInvites/FamilyInvitesList';
import ExpertChatMessages from './components/Expert/ExpertChatMessages';
import SystemFunctions from './components/SystemFunctions/SystemFunctions';
import PrizeOrdering from './components/Prize/PrizeOrdering';
import StepCompetitionDashboard from './components/StepCompetition/StepCompetitionDashboard';
import StepChallengeDashboard from './components/StepChallenge/StepChallengeDashboard';
import IdentityVerification from './components/IdentityVerification/IdentityVerification';
import Releases from './components/Releases/Releases';
import AllSubsidyOffers from './components/SubsidyOffers/AllSubsidyOffers';
import SupportCirclesAdmin from './components/SupportCircles/SupportCirclesAdmin';
import PartnersDashboard from './components/Partners/PartnersDashboard';
import MainBannerPage from './components/Banner/MainBannerPage';
import { MyMenu } from './Menu';
import myDataProvider from './providers/myDataProvider';
import Resources from './Resources';
function App() {
	const myTheme: ThemeOptions = {
		...defaultTheme,

		direction: 'rtl',
		components: {
			MuiCard: {
				styleOverrides: { root: { textAlign: 'center' } },
			},
			MuiTableCell: { defaultProps: { style: { textAlign: 'right', direction: 'rtl' } } },
			MuiSelect: {
				defaultProps: { dir: 'rtl', style: { paddingRight: 0 } },
				styleOverrides: { outlined: { textAlign: 'right' } },
			},
			MuiInputLabel: {
				styleOverrides: {
					root: {
						// Default styles for the unfocused state
						textAlign: 'right',
						transform: 'translate(-10px, 10px)',
						right: 0,
						paddingInlineStart: 0,
						left: 'auto',
						transformOrigin: 'top right',
						transition: 'all 0.3s ease', // Smooth transition for styling changes
						'&.MuiInputLabel-shrink': {
							// Styles when focused or input has a value
							textAlign: 'right', // Example: reset to default for focused state
							transform: 'translate(-14px, -5.5px) scale(0.75)', // Focused transformation
						},
					},
				},
			},

			MuiSvgIcon: {
				defaultProps: { direction: 'ltr', style: { right: 'auto', left: 6 } },
			},
			MuiOutlinedInput: {
				styleOverrides: {
					notchedOutline: {
						textAlign: 'right',
					},
				},
			},
		},
		typography: {
			// Use the system font instead of the default Roboto font.
			fontFamily: ['Open Sans', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Arial', 'sans-serif'].join(
				','
			),
		},
	};
	useEffect(() => {
		axios.defaults.headers.common['x-client'] = 'admin-web';
	}, []);

	return (
		<div className="App">
			<Admin
				authProvider={authProvider}
				dataProvider={myDataProvider}
				loginPage={AdminLogin}
				requireAuth
				theme={myTheme}
				layout={(props) => <Layout {...props} menu={MyMenu} />}
				dashboard={DashboardGate}
			>
				{(permissions) => (
					<>
						{Resources(permissions)}
						<CustomRoutes>
							<Route path="/stats" />
							<Route path="/instructor/expert-chat/messages" element={<ExpertChatMessages />} />
							<Route path="/event-invites" element={<EventInvitesList />} />
							<Route path="/family-invites" element={<FamilyInvitesList />} />
							<Route path="/system-functions" element={<SystemFunctions />} />
							<Route path="/prize-order" element={<PrizeOrdering />} />
							<Route path="/step-competition" element={<StepCompetitionDashboard />} />
							<Route path="/step-challenge" element={<StepChallengeDashboard />} />
							<Route path="/identity-verification" element={<IdentityVerification />} />
							<Route path="/releases" element={<Releases />} />
							<Route path="/subsidy-offers" element={<AllSubsidyOffers />} />
							<Route path="/support-circles" element={<SupportCirclesAdmin />} />
							<Route path="/partners" element={<PartnersDashboard />} />
							<Route path="/main-banner" element={<MainBannerPage />} />
						</CustomRoutes>
					</>
				)}
			</Admin>
		</div>
	);
}

export default App;
